<template>
    <div class="image-gallery">
        <div class="gallery">
            <VueSlickCarousel
                v-bind="slickSettings"
                class="gallery-slider"
                :ref="'gallerySlick' + _uid"
                :asNavFor="$refs['gallerySecondSlick' + _uid ]"
            >
                <picture v-for="(item, index) in items" v-on:click="showImage(index)" :key=index>
                    <img v-lazy="item.image.thumbnail" :alt="item.title" loading="lazy">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden"></span>
                    </div>
                </picture>
            </VueSlickCarousel>

        </div>
        <div class="modal fade modal-gallery" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">

                  <div class="modal-body loading" v-if="isLoading">
                    <loading-feedback :active="isLoading"></loading-feedback>
                  </div>

                  <div class="modal-body" v-if="modalItem && !isLoading">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>


                    <VueSlickCarousel
                        v-bind="secondSlickSettings"
                        class="gallery-slider gallery-slider-second"
                        :ref="'gallerySecondSlick' + _uid"
                        :asNavFor="$refs['gallerySlick' + _uid ]"
                    >
                      <img v-lazy="item.image.full" loading="lazy" :alt="item.title" v-for="(item, index) in items" :key=index>
                    </VueSlickCarousel>

                  </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        components: {VueSlickCarousel},
        props: ['items'],
        data() {
            return {
                slickSettings: {
                    dots: true,
                    arrows: true,
                    infinite: true,
                    speed: 300,
                    variableWidth: false,
                    adaptiveHeight: false,
                    draggable: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
                secondSlickSettings: {
                  dots: false,
                  arrows: true,
                  infinite: true,
                  speed: 300,
                  draggable: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
                isLoading: false,
                currentItem: 0
            }
        },
        computed: {
            modalItem: function () {
                return this.items[this.currentItem];
            }
        },
        methods: {
            showImage(index) {

                if (screen.width < 768 ) {
                  return;
                }

                $(this.$el).find('.modal').modal('show');
                this.$refs['gallerySecondSlick' + this._uid ].goTo(index);
            },
            nextImage() {
                if (this.currentItem < this.items.length) {
                    this.currentItem++
                    return;
                }
                this.currentItem = 0;
            },
            previousImage() {
                if (this.currentItem >= 0) {
                    this.currentItem--;
                    return;
                }

                this.currentItem = this.items.length - 1;
            }
        },
        beforeMount() {
            this.slickSettings.slidesToShow = parseInt($(".main-container") / 244);
            this.slickSettings.slidesToScroll = parseInt($(".main-container") / 244);
        },
        mounted() {
            this.slickSettings.slidesToShow = parseInt($(this.$el).find('.gallery-slider').width() / 244);
            this.slickSettings.slidesToScroll = parseInt($(this.$el).find('.gallery-slider').width() / 244);

            this.slickSettings.asNavFor = '#' +this._uid + '-slider-nav';
            this.secondSlickSettings.asNavFor = '#' +this._uid + '-slider-for';

            $(this.$el).find('.modal').on('shown.bs.modal', () => {
              this.slickSettings.arrows = false;
              this.$forceUpdate();
            });

            $(this.$el).find('.modal').on('shown.bs.hidden', () => {
              this.slickSettings.arrows = true;
              this.$forceUpdate();
            });

        }
    }
</script>
